import OtherInformationStep from './OtherInformationStep.vue'
import { otherInformationDescriptor } from './descriptor'
import { createOtherInformationController } from './other-information-controller'

const otherInformationStepImplementation = Object.freeze({
    descriptor: otherInformationDescriptor,
    component: OtherInformationStep,
    createController: createOtherInformationController,
})

export {
    OtherInformationStep,
    createOtherInformationController,
    otherInformationDescriptor,
    otherInformationStepImplementation,
}
